import { createClient } from "@supabase/supabase-js";
import { useState, useEffect } from "react";
import { useNavigate, useSearchParams } from "react-router-dom";
import CoorayAppBar from "../../shared/components/CoorayAppBar";
import { NavigationButtonType } from "../../shared/components/CoorayAppBar";
import UserRepository from "../../repository/UserRepository";
import { AnalyticsEvent } from "../../shared/analytics/AnalyticsEvent";
import { sendPageView } from "../../shared/utils/AnalyticsUtils";

const supabase = createClient('https://twblyxzvdbhlhxxurpno.supabase.co', 'eyJhbGciOiJIUzI1NiIsInR5cCI6IkpXVCJ9.eyJpc3MiOiJzdXBhYmFzZSIsInJlZiI6InR3Ymx5eHp2ZGJobGh4eHVycG5vIiwicm9sZSI6ImFub24iLCJpYXQiOjE3NjAzNDMzNTMsImV4cCI6MjA3NTkxOTM1M30.cOz8DeHN7L00i3VN2wF5NXs2quw95Eaz3-8IQs4ltgw')

export default function CompleteProfilePage({ analytics }) {

    const [loadingText, setLoadingText] = useState(null)
    const [toastErrorMessage, setToastErrorMessage] = useState(null)
    const [name, setName] = useState("")
    const navigate = useNavigate()

    useEffect(() => {
        const userRepository = new UserRepository()
  
        async function getUserProfile() {
            setLoadingText("Loading ...")
            const {
              data: { user },
            } = await supabase.auth.getUser()
            if (user == null) {
              navigate("/login", {replace: true})
            } else {
              try {
                await userRepository.getUserProfile()
                navigate("/dashboard", {replace: true})
              } catch(e) {
                console.log(`get user profile error ${e.response.status}`)
                setLoadingText(null)
              }
            }
          }
  
          getUserProfile()

          sendPageView(analytics, AnalyticsEvent.COMPLETE_PROFILE_VIEW, {})
  
    }, [])

    useEffect(() => {
        if (toastErrorMessage) {
            setTimeout(() => {
                setToastErrorMessage(null)
            }, 3000)
        }
    }, [toastErrorMessage])

    async function saveProfile() {
        setLoadingText("Saving ...")
        const userRepository = new UserRepository()
        try {
            await userRepository.updateUserProfile(name)
        } catch(e) {
            console.log(`update user profile error ${e.response.status}`)
            setLoadingText(null)
            setToastErrorMessage("Sorry, something went wrong. Please try again.")
            return
        }
        navigate("/dashboard", {replace: true})
    }

    function onNameChange(event) {
        setToastErrorMessage(null)
        setName(event.target.value)
    }

    function onBackPressed() {
        onSignOutClick()
    }

    async function onSignOutClick() {
        const { error } = await supabase.auth.signOut(
            {
                scope: "local"
            }
        )
        console.log(`sign out error is ${JSON.stringify(error)}`)
        navigate("/login", { replace: true })
    }

    function onSaveClick() {
        if (!name) {
            setToastErrorMessage("Name cannot be empty")
        } else {
            saveProfile()
        }
    }

    return (
        <div className="h-full flex flex-col bg-base-200">
            <CoorayAppBar title={"👋🏼 Complete Your Profile"} onBackPressed={onBackPressed} navigationType={NavigationButtonType.Close}/>
            <div className="bg-base-300 px-4 py-4">
                <div className="max-w-full text-base-content text-base">{`One more step and you're in 🙌🏼`}</div>
            </div>
            <div className="form-control w-full px-4 pt-4 flex-1">
                <label className="label">
                    <span className="label-text">Your name (e.g. John Doe)</span>
                </label>
                <input type="text" placeholder="e.g. John Doe ..." className="input input-bordered w-full rounded-md" onChange={onNameChange} value={name}/>
            </div>
            <div className='fixed bottom-0 right-4 pb-4 w-full text-center'>
                <button className="btn btn-success normal-case ml-4" onClick={ onSaveClick }>
                    <svg className="w-6 h-6" viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg" fill="none">
                        <path className="stroke-success-content" strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M8 4H6a2 2 0 0 0-2 2v12a2 2 0 0 0 2 2h12a2 2 0 0 0 2-2V7.828a2 2 0 0 0-.586-1.414l-1.828-1.828A2 2 0 0 0 16.172 4H15M8 4v4a1 1 0 0 0 1 1h5a1 1 0 0 0 1-1V4M8 4h7M7 17v-3a1 1 0 0 1 1-1h8a1 1 0 0 1 1 1v3"/>
                    </svg>
                    Save
                </button>
            </div>

            {loadingText &&
            <div className='w-full h-screen fixed top-0 flex flex-col items-center justify-center backdrop-blur-sm bg-base-100/30'>
                <div className="loading loading-infinity loading-lg"></div>
                <div className='font-normal text-base-content mt-2'>{loadingText}</div>
            </div>
            }

            {
                toastErrorMessage && <div className="toast z-10">
                  <div className="alert alert-info">
                  <span className="text-sm">{toastErrorMessage}</span>
                  </div>
              </div>
            }
        </div>
    )
}
